export default "__VITE_ASSET__f2f26acb__"